import { render, staticRenderFns } from "./FiLifeFilesCard.vue?vue&type=template&id=1dae9776"
import script from "./FiLifeFilesCard.vue?vue&type=script&lang=js"
export * from "./FiLifeFilesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports